import * as React from "react";
import Octicon, { getIconByName } from '@github/octicons-react'; //https://octicons.github.com/

export class DeleteButtonGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = { dataTarget: '', onClick: null };
    }

    render() {
        if (this.props.ShowIcon) {
            return (
                <button className='btn btn-outline-danger m-1 gridButton' data-toggle='modal' data-target={this.props.dataTarget} onClick={this.props.onClick}>
                    <Octicon icon={getIconByName('trashcan')} className='mb-1' ariaLabel={this.props.ariaLabel} /></button>
            );
        }

        return (
            <a id={this.props.id} className='btn btn-link link' tabIndex='0' data-toggle='modal' data-target={this.props.dataTarget} onClick={this.props.onClick} aria-label={this.props.ariaLabel}>Delete</a>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Controls/DeleteButtonGrid.js